module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5856_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.206993ce.jpg";